export enum Roles {
  IVForce_ProcessManager = 'IVForce_ProcessManager',
  IVForce_TechnicalManager = 'IVForce_TechnicalManager',
  IVForce_CommercialManager = 'IVForce_CommercialManager',
  IVForce_Appraiser = 'IVForce_Appraiser',
  IVForce_Customer = 'IVForce_Customer',
  IVForce_Customer_Advanced = 'IVForce_Customer_Advanced',

  IVForce_User = 'IVForce_User',
  ROLE_IVFORCE = 'ROLE_IVFORCE',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}

const managers = [Roles.IVForce_ProcessManager, Roles.IVForce_TechnicalManager, Roles.IVForce_CommercialManager];

export const authoritiesDefinition = {
  entities: {
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    pages: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      list: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      },
      add: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      },
      detail: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        actions: {
          canEditImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        profile: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        'allowed-roles': {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        'billing-info': {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        deliverables: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        appraisals: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        collaborator: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        users: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canEditUsers: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canChangeUsersPassword: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
      },
    },
  },
  'account-management': {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    pages: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      detail: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        fastActionButtons: {
          canAddPaymentMethod: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        payment: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEditBillingData: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canDeletePaymentMethod: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canSetDefaultPaymentMethod: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        invoices: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canDownload: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        license: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        'report-customization': {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
      },
    },
  },
  orders: {
    access: [
      'LicenseeUserRole_Root',
      'LicenseeUserRole_CustomerBasic',
      'LicenseeUserRole_CustomerAdvanced',
      'LicenseeUserRole_ProcessManager',
      'LicenseeUserRole_TechnicalManager',
      'LicenseeUserRole_CommercialManager',
    ],
    enable: [
      'LicenseeUserRole_Root',
      'LicenseeUserRole_CustomerBasic',
      'LicenseeUserRole_CustomerAdvanced',
      'LicenseeUserRole_ProcessManager',
      'LicenseeUserRole_TechnicalManager',
      'LicenseeUserRole_CommercialManager',
    ],
    'simple-notes': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          fastActions: {
            canSentToRegister: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canSetSuccessReceivedFromRegister: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            canSetDeliveredToClient: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          form: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          documents: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            add: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        create: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
      },
    },
    requests: {
      access: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      enable: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      pages: {
        access: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        enable: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        list: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          topButtonActions: {
            canAddRequestButton: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            canDownloadExcel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
        },
        detail: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          fastActions: {
            canCancel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canResendEmail: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAcceptManually: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canCreateAppraisal: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAddInvoice: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canSendToClient: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canShowCopySelector: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canEditBillingData: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
            feeOption: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            incomeOutComeProvision: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            selectPrescriber: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            selectCustomer: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            addManualCustomer: ['LicenseeUserRole_CustomerAdvanced'],
            visitContactData: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
              'LicenseeUserRole_CustomerAdvanced',
            ],
            exchange: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            conditionsCheck: ['LicenseeUserRole_CustomerAdvanced'],
          },
          documents: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canDownload: [
                'LicenseeUserRole_Root',
                'LicenseeUserRole_CustomerAdvanced',
                'LicenseeUserRole_ProcessManager',
                'LicenseeUserRole_TechnicalManager',
                'LicenseeUserRole_CommercialManager',
              ],
            },
          },
          'payment-history': {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
          },
          appraisals: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
          },
          billing: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        massive: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          topButtonActions: {
            canAddMassiveLoadButton: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canDownloadFile: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          add: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
      },
    },
    'quality-control': {
      access: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      enable: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      pages: {
        access: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        enable: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        list: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          actions: {
            canCreateOrder: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canShowTopFilterBar: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        massive: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          actions: {
            canAssignManagerProcessUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignManagerTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canCancel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canFinishValidation: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canStartValidation: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canReject: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canMarkAsDelivered: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          documents: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canDownload: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canUpload: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          'registral-plat': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canSave: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canSaveAndFinish: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    appraisals: {
      access: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerBasic',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      enable: [
        'LicenseeUserRole_Root',
        'LicenseeUserRole_CustomerBasic',
        'LicenseeUserRole_CustomerAdvanced',
        'LicenseeUserRole_ProcessManager',
        'LicenseeUserRole_TechnicalManager',
        'LicenseeUserRole_CommercialManager',
      ],
      pages: {
        access: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerBasic',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        enable: [
          'LicenseeUserRole_Root',
          'LicenseeUserRole_CustomerBasic',
          'LicenseeUserRole_CustomerAdvanced',
          'LicenseeUserRole_ProcessManager',
          'LicenseeUserRole_TechnicalManager',
          'LicenseeUserRole_CommercialManager',
        ],
        dashboard: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          fileVolume: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          fileAverageTime: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          filters: {
            purpose: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            customer: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            prescriber: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            portfolios: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            advanced: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          clickStepper: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
        },
        list: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerBasic',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerBasic',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          actions: {
            canDownloadExcel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canFilter: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            canShowTopFilterBar: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignMultipleProcessManagers: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            canAssignMultipleTechnicalManagers: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        massive: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          pages: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            list: {
              access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              actions: {
                canFilter: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              },
            },
            add: {
              access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
            detail: {
              access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              actions: {
                canDownloadFile: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              },
            },
          },
        },
        portfolios: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          list: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canFilter: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          add: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canDeleteValuations: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canAddValuations: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
        incidents: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          actions: {
            canDownloadExcel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canFilter: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
          },
        },
        claims: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canFilter: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        detail: {
          access: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerBasic',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          enable: [
            'LicenseeUserRole_Root',
            'LicenseeUserRole_CustomerBasic',
            'LicenseeUserRole_CustomerAdvanced',
            'LicenseeUserRole_ProcessManager',
            'LicenseeUserRole_TechnicalManager',
            'LicenseeUserRole_CommercialManager',
          ],
          actions: {
            canAssignManagerProcessUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignManagerTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canShowManagerProcessUser: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
            ],
            canShowTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canShowManagerTechnicalUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canCancel: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canDuplicate: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canStartValidation: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canMarkAsDelivered: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canValidate: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canReject: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canSendToClient: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canMarkAsDeliveredToClient: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canShowBtnViewCustomer: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
            references: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            request: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            requestData: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            customer: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            prescriber: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            orderFeatures: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            relatedAppraisals: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            incomeExpensesProvision: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            incomeExpensesConfirmed: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            exchange: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          documents: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canAdd: [
                'LicenseeUserRole_Root',
                'LicenseeUserRole_CustomerBasic',
                'LicenseeUserRole_CustomerAdvanced',
                'LicenseeUserRole_ProcessManager',
                'LicenseeUserRole_TechnicalManager',
                'LicenseeUserRole_CommercialManager',
              ],
              canDelete: [
                'LicenseeUserRole_Root',
                'LicenseeUserRole_CustomerBasic',
                'LicenseeUserRole_CustomerAdvanced',
                'LicenseeUserRole_ProcessManager',
                'LicenseeUserRole_TechnicalManager',
                'LicenseeUserRole_CommercialManager',
              ],
              canSetAsPrintable: [
                'LicenseeUserRole_Root',
                'LicenseeUserRole_CustomerBasic',
                'LicenseeUserRole_CustomerAdvanced',
                'LicenseeUserRole_ProcessManager',
                'LicenseeUserRole_TechnicalManager',
                'LicenseeUserRole_CommercialManager',
              ],
              canDownload: [
                'LicenseeUserRole_Root',
                'LicenseeUserRole_CustomerBasic',
                'LicenseeUserRole_CustomerAdvanced',
                'LicenseeUserRole_ProcessManager',
                'LicenseeUserRole_TechnicalManager',
                'LicenseeUserRole_CommercialManager',
              ],
            },
            appraisalDocTable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            appraisalAssetDocTable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          incidents: {
            access: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            enable: [
              'LicenseeUserRole_Root',
              'LicenseeUserRole_CustomerBasic',
              'LicenseeUserRole_CustomerAdvanced',
              'LicenseeUserRole_ProcessManager',
              'LicenseeUserRole_TechnicalManager',
              'LicenseeUserRole_CommercialManager',
            ],
            actions: {
              canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canResolve: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          revisions: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          claims: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canResolve: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          tracks: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          'message-board': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canReply: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          invoicing: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          'appraisal-relationship': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          report: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            list: {
              access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              actions: {
                canGenerateDraft: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                canSetDeliverables: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              },
            },
            detail: {
              access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              commonAssets: {
                access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                locationAndSurroundings: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canGetAutomaticData: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                terrainFeatures: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                landDescription: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                buildingInfo: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                urbanisticSituation: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                checkValidations: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                conditionings: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                buildingState: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
              },
              assets: {
                access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                actions: {
                  canMultipleEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canCreateCluster: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canValuateTerrains: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canModifyStructure: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canImportFromRequest: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canDuplicate: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canAddAnnex: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canMakeMainAsset: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  canExtractAsset: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                },
                identification: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                location: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                typology: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                surfaces: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                locationAndSurroundings: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canGetAutomaticData: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                landDescription: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                buildingInfo: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                propertyCharacteristics: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                terrainFeatures: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                urbanisticSituation: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                tenures: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                checkValidations: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                conditionings: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                photos: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canSetAsPrintable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canMakeItMain: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canMultipleSelect: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                documents: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canSetAsPrintable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canDownload: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                appraisalAssetLogChanges: {
                  access: ['LicenseeUserRole_Root', null, 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', null, 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                buildingState: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                valuations: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canRecalculate: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'comparison-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'cost-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'discount-cashflow-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'contract-cashflow-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'legal-maximum-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'other-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'dynamic-residual-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'static-residual-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'crawled-method': {
                    access: [],
                    enable: [],
                  },
                },
              },
              clusters: {
                access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                actions: {
                  canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                },
                detail: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                valuations: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canAdd: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canRecalculate: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'comparison-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'cost-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'discount-cashflow-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'contract-cashflow-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'legal-maximum-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'other-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'dynamic-residual-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'static-residual-method': {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  'crawled-method': {
                    access: [],
                    enable: [],
                  },
                },
              },
              'terrain-clusters': {
                access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                actions: {
                  canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                },
                detail: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                },
                calculations: {
                  access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  actions: {
                    canAddConstruction: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canAddInconme: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canAddExpense: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    canSave: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                  },
                  buildingElements: {
                    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    'comparison-method': {
                      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    },
                    'other-method': {
                      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  financial: {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    'payment-summary': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canDownloadInvoices: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAskForConfirmation: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canResetInvoices: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          fastActions: {
            canAskForConfirmation: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canDownloadDraft: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canResetInvoice: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          detail: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
      },
    },
    'code-management': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            addNewCode: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            edit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          form: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
      },
    },
  },
  participants: {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    customers: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewClient: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            addProfilePhoto: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          'billing-info': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          appraisals: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          users: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canEditUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canEditPassword: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          deliverables: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    professionals: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            addNewProfessional: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            addProfilePhoto: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            change_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            addIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          'billing-info': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          collaborator: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          appraisals: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          invoices: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          schedule: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          incompatibilities: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          preferences: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canSetDistance: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          documents: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    'requester-companies': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewPrescriptorComapy: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEditImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          'billing-info': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          appraisals: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          users: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canEditUsers: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canChangeUsersPassword: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          deliverables: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          collaborator: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
  },
  'users-credentials': {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    'process-manager-user': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canChangeImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canChange_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignRoles: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAddIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          incompatibilities: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    'technical-manager-user': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canChangeImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canChange_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignRoles: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAddIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          incompatibilities: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    'commercial-manager-user': {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canChangeImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canChange_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAssignRoles: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAddIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          incompatibilities: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    users: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      pages: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        list: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canAddNewUser: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
        add: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        detail: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canChangeImage: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          fastActions: {
            canChange_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canAddIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
          profile: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          incompatibilities: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          preferences: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canSetDistance: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          documents: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          collaborator: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          appraisals: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          invoices: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          schedule: {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
              canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
          'billing-info': {
            access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            actions: {
              canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            },
          },
        },
      },
    },
    incompatibilities: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    },
  },
  actives: {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
  },
  wiki: {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
  },
  'my-profile': {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    pages: {
      access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
      detail: {
        access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        fastActions: {
          canChange_password: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          canAddIncompatibilities: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        profile: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
        },
        incompatibilities: {
          access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          actions: {
            canEdit: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
            canDelete: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
          },
        },
      },
    },
  },
  academy: {
    access: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
    enable: ['LicenseeUserRole_Root', 'LicenseeUserRole_ProcessManager', 'LicenseeUserRole_TechnicalManager', 'LicenseeUserRole_CommercialManager'],
  },
};
